import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { NavbarComponent } from './navbar/navbar.component';
import { RegisterComponent } from './register/register.component';
import { CommonModule, LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserInterceptor } from './user-interceptor';
import { ErrorInterceptor } from './error-interceptor';
import { HomeComponent } from './home/home.component';
import { FancyComponent } from './fancy/fancy.component';
import { MatchComponent } from './match/match.component';
import { MatchActivitiesComponent } from './match-activities/match-activities.component';
import { AllMatchComponent } from './all-match/all-match.component';
import { FancyActivitiesComponent } from './fancy-activities/fancy-activities.component';
import { Home2Component } from './home2/home2.component';
import { MatchesListComponent } from './matches-list/matches-list.component';
import { SettingsComponent } from './settings/settings.component';
import { LivetvComponent } from './livetv/livetv.component';
import { DMatchesComponent } from './d-matches/d-matches.component';
import { TestFancyComponent } from './test-fancy/test-fancy.component';
import { ServerStatusComponent } from './server-status/server-status.component';
import { AddManualMatchComponent } from './add-manual-match/add-manual-match.component';
import { SetLimitComponent } from './set-limit/set-limit.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavbarComponent,
    RegisterComponent,
    HomeComponent,
    FancyComponent,
    MatchComponent,
    MatchActivitiesComponent,
    AllMatchComponent,
    FancyActivitiesComponent,
    Home2Component,
    MatchesListComponent,
    SettingsComponent,
    LivetvComponent,
    DMatchesComponent,
    TestFancyComponent,
    ServerStatusComponent,
    AddManualMatchComponent,
    SetLimitComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: UserInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent],
  //entryComponents: [ErrorComponent]
})
export class AppModule { }
